import React, { Fragment } from 'react';
import intl from 'react-intl-universal';
import PropTypes from 'prop-types';
import { Avatar, Select, Icon } from 'components';
import { User, Username, SectionTitle } from './Styles';

import { UserContextMenu } from 'components/Menu';

import { IssueState, IssueStatus } from 'shared/constants/issues';
import localData from 'utils/localData';
import { getUserFullName } from 'utils/name';
import { IssuePropTypes } from 'shared/propTypes/issueType';
import { LANGUAGE, USER_DATA } from 'shared/constants/users';

const propTypes = {
  issue: PropTypes.shape(IssuePropTypes).isRequired,
  doctors: PropTypes.arrayOf(Object),
  setConfirmModalInfo: PropTypes.func,
  setConfirmModalOpen: PropTypes.func,
  setConfirmModalUpdateData: PropTypes.func,
};

const BatchEditModalAssignees = ({
  issue,
  doctors,
  setConfirmModalInfo,
  setConfirmModalOpen,
  setConfirmModalUpdateData,
}) => {
  const getUserById = (userId) => doctors.find((user) => user.id === userId);
  const handleAssignDoctor = (issue, userIds) => {
    const users = userIds.map(getUserById);
    const updatedFields = {
      userIds,
      users: users,
      status: issue.status,
      state: issue.state,
    };
    const doctorUsers = issue.userIds;
    if (
      doctorUsers.length === 0 &&
      issue.state === IssueState.NORMAL &&
      issue.status === IssueStatus.CHECKREADY
    ) {
      updatedFields.status = IssueStatus.DOCTORASSIGNED;
    }
    if (
      users.length === 0 &&
      [
        IssueStatus.DOCTORASSIGNED,
        IssueStatus.CHECKREADY,
        IssueStatus.REPORTREADY,
        IssueStatus.SENDBACK,
        IssueStatus.DONE,
      ].includes(issue.status)
    ) {
      updatedFields.state = IssueState.WARNING;
    }
    setConfirmModalInfo({
      destination: updatedFields.status,
      issueState: updatedFields.state,
      AssignType: doctorUsers.length < users.length ? 'assign' : 'unassign',
    });
    setConfirmModalUpdateData(updatedFields);
    setConfirmModalOpen(true);
  };

  const userOptions = doctors.map((user) => ({
    value: user.id,
    label: user.username,
  }));

  return (
    <Fragment>
      <SectionTitle>
        {intl.get('issue_details_text_doctor_in_charge')}
      </SectionTitle>
      <Select
        isMulti
        variant="empty"
        dropdownWidth={240}
        placeholder={intl.get('issue_details_unassigned')}
        name="assignees"
        value={issue.userIds}
        options={userOptions}
        onChange={(userIds) => {
          handleAssignDoctor(issue, userIds);
        }}
        renderValue={({ value: userId, removeOptionValue }) =>
          renderUser(getUserById(userId), true, removeOptionValue)
        }
        renderOption={({ value: userId }) =>
          renderUserWithoutQuota(getUserById(userId), false)
        }
      />
    </Fragment>
  );
};

const renderUser = (user, isSelectValue, removeOptionValue) => {
  const preferredLanguage = localData.get(USER_DATA.PREFFERED_LANGUAGE);

  return (
    <UserContextMenu username={user.username}>
      <User
        key={user.id}
        isSelectValue={isSelectValue}
        withBottomMargin={!!removeOptionValue}
        onClick={() => removeOptionValue && removeOptionValue()}>
        <Avatar
          name={user.firstName}
          size={24}
          avatarUrl={null}
          className={null}
        />
        <Username>
          {preferredLanguage === LANGUAGE.ENGLISH
            ? user.firstName + ' ' + user.lastName
            : user.lastName + ' ' + user.firstName}
        </Username>
        {removeOptionValue && <Icon type="close" top={1} />}
      </User>
    </UserContextMenu>
  );
};

const renderUserWithoutQuota = (user, isSelectValue) => {
  return (
    <User
      key={user.id}
      isSelectValue={isSelectValue}
      withBottomMargin={false}
      onClick={() => {}}>
      {/* <Avatar avatarUrl={user.avatarUrl} name={user.username} size={24} /> */}
      <Username style={{}}>
        {' '}
        {getUserFullName(user.firstName, user.lastName)}{' '}
      </Username>
    </User>
  );
};

BatchEditModalAssignees.propTypes = propTypes;
BatchEditModalAssignees.displayName = 'BatchEditModalAssignees';

export default BatchEditModalAssignees;
